import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import {noop} from 'shared/tools';
import {auth} from 'main/tools';
import $ from 'jquery';

class FillablePdfPreviewState {
  pdfUrl;
  companyDocument = {};

  annotations = [];
  currentAnnotation;
  pageNumber = 1;
  isLoaded = false;
  markedComplete = false;
  callbacks = {
    onEmployeeSignatureUpdated: noop
  };

  constructor(pdfUrl, annotations, pageNumber, companyDocument) {
    makeAutoObservable(this);

    this.pdfUrl = pdfUrl;
    this.companyDocument = companyDocument;
    this.annotations = annotations;
    this.pageNumber = pageNumber;
  }

  onLoaded(selectPage) {
    this.selectPage = selectPage;
    this.isLoaded = true;
  }

  changePage(pageNumber) {
    this.pageNumber = pageNumber;
    this.setAnnotation(this.nextAnnotationOnCurrentPage);
  }

  goToFirstAnnotationOnPage(pageNumber) {
    if(pageNumber === this.pageNumber) {
      this.setAnnotation(this.nextAnnotationOnCurrentPage);
    } else {
      this.selectPage(pageNumber);
    }
  }

  goToNextAnnotation() {
    this.setAnnotation(this.nextAnnotationOnCurrentPage);
    if (!this.currentAnnotation) {
      let annotation = _.find(this.sortedAnnotationsByPageNumber, a => this.isNextEmptyAnnotation(a));
      if (annotation) {
        this.goToFirstAnnotationOnPage(annotation.annotation.pageNumber);
      } else {
        annotation = _.find(this.sortedAnnotationsByPageNumber, (a) => !a.isValid);
        if (annotation) {
          this.goToFirstAnnotationOnPage(annotation.annotation.pageNumber);
        } else {
          this.markedComplete = true;
          this.transitionToCompleteButton();
        }
      }
    }
  }

  setAnnotation(annotation) {
    this.currentAnnotation = annotation;
    if (annotation) {
      this.transitionToAnnotation();
    }
  }

  updateEmployeeSignature(signatureData) {
    this.callbacks.onEmployeeSignatureUpdated(signatureData);

    for (const annotation of this.employeeSignatureAnnotations) {
      annotation.signatureData = signatureData;
    }
  }

  get assignedAnnotations() {
    return _.filter(this.annotations, annotationViewModel => this.isAssignedAnnotation(annotationViewModel));
  }

  get currentPageAnnotations() {
    return _.filter(this.annotations, { annotation: { pageNumber: this.pageNumber }});
  }

  get currentPageAssignedAnnotations() {
    return _.filter(this.assignedAnnotations, { annotation: { pageNumber: this.pageNumber }});
  }

  get sortedAnnotations() {
    return _.sortBy(this.currentPageAssignedAnnotations, ['annotation.state.top', 'annotation.state.left']);
  }

  get helperDirectsToDifferentPage() {
    return !this.currentAnnotation || (this.currentAnnotation === _.last(this.sortedAnnotations) && this.currentAnnotation.isValid);
  }

  get readyToComplete() {
    const incompleteAnnotations = _.filter(this.assignedAnnotations, a => !a.isValid);
    if (incompleteAnnotations.length) {
      return false;
    }

    const lastNonEmptyAnnotationIndex = _.findLastIndex(this.sortedAnnotationsByPageNumber, a => a.isEmpty);
    if (lastNonEmptyAnnotationIndex === -1) {
      return true;
    }

    if (this.currentAnnotation) {
      const {id} = this.currentAnnotation.annotation.annotationArgs;
      const currentIndex = _.findIndex(this.sortedAnnotationsByPageNumber, s => s.annotation.annotationArgs.id === id);
      return currentIndex >= lastNonEmptyAnnotationIndex;
    } else {
      return this.sortedAnnotationsByPageNumber[lastNonEmptyAnnotationIndex].annotation.pageNumber <= this.pageNumber;
    }
  }

  get sortedAnnotationsByPageNumber() {
    return _.sortBy(this.assignedAnnotations, ['annotation.pageNumber'], ['annotation.state.top'], ['annotation.state.left']);
  }

  get nextAnnotationOnCurrentPage() {
    if (this.currentAnnotation) {
      const {id} = this.currentAnnotation.annotation.annotationArgs;
      const currentIndex = _.findIndex(this.sortedAnnotations, s => s.annotation.annotationArgs.id === id);
      return _.find(this.sortedAnnotations, (a, index) => {
        return a.isEmpty && index > currentIndex;
      });
    } else {
      return _.find(this.sortedAnnotations, a => a.isEmpty);
    }
  }

  get employeeSignatureAnnotations() {
    return _.filter(this.assignedAnnotations, { annotation: { annotationType: 'employee_signature'} });
  }

  isNextEmptyAnnotation(annotationViewModel) {
    const annotationPageNumber = annotationViewModel.annotation.pageNumber;

    return annotationViewModel.isEmpty && this.pageNumber < annotationPageNumber;
  }

  transitionToAnnotation() {
    const $pdfViewerElement = $('#pdfViewerContainer');
    const topOfAnnotation = $pdfViewerElement.offset().top - $pdfViewerElement.position().top + this.currentAnnotation.annotation.state.top;
    $('html, body').animate({scrollTop: topOfAnnotation - 300}, 300);

    const annotationElement = $(`#${this.currentAnnotation.annotation.annotationArgs.id}`);
    annotationElement.focus();
    if (annotationElement[0] && this.currentAnnotation.annotation.annotationArgs.inputType !== 'checkbox')
      annotationElement[0].click();
  }

  transitionToCompleteButton() {
    const $pdfViewerElement = $('#pdfViewerContainer');
    const bottom = $pdfViewerElement.offset().top - $pdfViewerElement.position().top + $pdfViewerElement.outerHeight(true);
    $('html, body').animate({scrollTop: bottom - 300}, 300);
  }

  registerCallback(event, callback) {
    switch (event) {
      case 'onEmployeeSignatureUpdated':
        this.callbacks[event] = callback;
        break;
      default:
        throw new Error(`Callback ${event} is not supported.`);
    }
  }

  isAssignedAnnotation(annotationViewModel) {
    return (!annotationViewModel.annotation.assignee && this.companyDocument.assignedToPrimaryEmployee) ||
      annotationViewModel.annotation.assignee == auth.employee.id;
  }
}

export default FillablePdfPreviewState;
